import { OFFER_LETTER_CONSTANTS, OFFER_LETTER_MAPPER } from "../constants/common";

export function formatVariablesFromHTML(htmlString) {
  if (!htmlString) return htmlString;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Helper to unwrap spans that were added for highlighting
  // We specifically look for spans that might have been added by unformatVariablesToHTML
  const spans = doc.querySelectorAll("span");
  spans.forEach((span) => {
    // Check if it looks like our variable span (contains <Variable Name>)
    // AND if it has the specific blue color we use for highlighting
    const style = span.getAttribute("style");
    const isBlue =
      style &&
      (style.includes("#2563eb") || style.includes("rgb(37, 99, 235)"));

    // We only unwrap if it's the blue highlighting span.
    // We do NOT unwrap other spans (which might be used for other styling)
    // unless we are sure they are just wrappers for the variable.
    if (isBlue) {
      // Unwrap: replace span with its children
      const parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    }
  });

  const strongs = doc.querySelectorAll("strong");
  strongs.forEach((strong) => {
    const style = strong.getAttribute("style");
    const isBlue =
      style &&
      (style.includes("#2563eb") || style.includes("rgb(37, 99, 235)"));

    if (isBlue) {
      // Preserve the strong tag, but remove the blue highlight color
      let newStyle = style
        .replace(/color:\s*#2563eb;?/gi, "")
        .replace(/color:\s*rgb\(37,\s*99,\s*235\);?/gi, "")
        .trim();

      if (newStyle === "") {
        strong.removeAttribute("style");
      } else {
        strong.setAttribute("style", newStyle);
      }
    }
  });



  // Now traverse text nodes to replace <Variable Name> with {{key}}
  const walker = document.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  let node;
  const nodesToReplace = [];

  while ((node = walker.nextNode())) {
    if (node.nodeValue.match(/<.*?>/)) {
      nodesToReplace.push(node);
    }
  }

  nodesToReplace.forEach((node) => {
    const newValue = node.nodeValue.replace(/<(.*?)>/g, (match, p1) => {
      const key = OFFER_LETTER_MAPPER[p1.trim()];
      return key ? `{{${key}}}` : match;
    });
    node.nodeValue = newValue;
  });

  return doc.body.innerHTML;
}

export function unformatVariablesToHTML(str) {
  if (!str) return str;

  return str.replaceAll(
    /{{(.*?)}}/g,
    (_, variableName) =>
      `<span style="color:#2563eb;">&lt;${OFFER_LETTER_CONSTANTS[
      variableName.trim()
      ]}&gt;</span>`
  );
}
